import axios from 'axios';
import * as XLSX from 'xlsx';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { FilterMatchMode } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { confirmDialog } from 'primereact/confirmdialog';
import { Tag } from 'primereact/tag';
import { Skeleton } from 'primereact/skeleton';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { Calendar } from 'primereact/calendar';
import { formatedDate } from '../../Helper/constent';
import { InputNumber } from 'primereact/inputnumber';

const EmployeeSalesReport = () => {
    const { apiUrl, apiHeadersJson, store_id } = useContext(ConfigContext);
    const [rows, setRows] = useState([]);
    const [Status, setStatus] = useState(null);
    const [prStatus, setPrStatus] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [keyword, setKeyword] = useState(null);
    const [callApi, setCallApi] = useState(true);
    const toast = useRef(null);
    const [dataTableLoading, setDataTableLoading] = useState(true);
    const { limit, order } = useParams();

    const [rowsPerPage, setRowsPerPage] = useState(limit || 10);
    const [sortOrder, setSortOrder] = useState(order, 'DESC');

    const navigate = useNavigate();
    const headers = apiHeadersJson;
    if (!limit || !order || !['ASC', 'DESC'].includes(order.toUpperCase())) {
        navigate('/EmployeeSalesReport/30/DESC')
    }


    const GetList = async () => {
        setDataTableLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Reports/GetEmployeeSaleReport`, { params: { store_id, limit, order, keyword, action_status: Status === "All" ? '' : Status, employee_sale_status: prStatus === "All" ? '' : prStatus, start_date: startDate, end_date: endDate }, headers });
            const { success, data, message } = response.data;
            setCallApi(false);
            if (success) {
                setRows(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setDataTableLoading(false);
        }
    };


    useEffect(() => {
        GetList();
    }, [limit, order]);

    useEffect(() => {
        callApi && GetList();
    }, [callApi]);
    useEffect(() => {
        store_id && GetList();
    }, [store_id]);

    useEffect(() => {
        const timer = setTimeout(() => { keyword && GetList(); }, 1500);
        return () => clearTimeout(timer);
    }, [keyword]);

    const clearFilters = () => {
        setKeyword("");
        setStartDate(null);
        setEndDate(null);
        setStatus("");
        setPrStatus("");
        setCallApi(true)
    };
    const applyFilters = () => {
        GetList();
        setCallApi(true)
    };


    const paginatorLeft = <Button type="button" icon="pi pi-refresh" text onClick={GetList} />;
    const paginatorRight = <></>;

    const ActionBody = (data) => {
        const GetActionStatusById = (info) => {
            let value = info.action_type == 1 ? 'Edited' : info.action_type == 2 ? 'Deleted' : '';
            let severity = info.action_type == 1 ? 'info' : info.action_type == 2 ? 'danger' : '';
            return { value, severity };
        };

        const CheckShowBtns = (info) => {
            const edit = info.employee_sale_status == 1 && info.action_type != 2;
            const verify = info.employee_sale_status == 1 && info.action_type != 2;
            const deleteBtn = info.employee_sale_status == 1 && info.action_type != 2;
            return { edit, verify, deleteBtn };
        };

        return (
            <>
                {data.action_type != 0 && (
                    <Tag severity={GetActionStatusById(data).severity} value={GetActionStatusById(data).value}></Tag>
                )}
                <div className="ms-2 btn-group" role="group" aria-label="Action Buttons">
                    {/* Edit Button */}
                    {CheckShowBtns(data).edit && (
                        <NavLink to={`/EmployeeSales/${data.employee_sale_id}/${data.store_id}`} className="btn btn-primary">
                            <i className="pi pi-pen-to-square"></i>
                        </NavLink>
                    )}
                    {/* Verify Button */}
                    {CheckShowBtns(data).verify && (
                        <button
                            className="btn btn-success"
                            onClick={() => confirmVerify(data.employee_sale_id, data.store_id)}
                        >
                            <i className="pi pi-check-square"></i>
                        </button>
                    )}
                    {/* Delete Button */}
                    {CheckShowBtns(data).deleteBtn && (
                        <button
                            className="btn btn-danger"
                            onClick={() => confirmDelete(data.employee_sale_id)}
                        >
                            <i className="pi pi-trash"></i>
                        </button>
                    )}
                </div>
            </>
        );
    };

    const confirmVerify = (id, store_id) => {
        confirmDialog({
            message: 'Are you sure you want to Paid this Employee Sale?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => VerifyPurchaseProducts(id, store_id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Delete operation cancelled', life: 3000 });
            }
        });
    };

    const VerifyPurchaseProducts = async (id, store_id) => {
        try {
            const response = await axios.post(`${apiUrl}/Management/PaidEmployeeSale`, { employee_sale_id: id, store_id }, { headers });
            const { success, message } = response.data;
            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const LinkBody = (data) => {
        return (
            data.invoice_number ?
                <NavLink to={`/ViewEmployeeSales/${data.employee_sale_id}`} className={'text-primary'} style={{ cursor: 'pointer', textDecoration: 'none' }}>{data.invoice_number}</NavLink>
                :
                <NavLink to={`/ViewEmployeeSales/${data.employee_sale_id}`} className={'text-primary'} style={{ cursor: 'pointer', textDecoration: 'none' }}>{"View Sale"}</NavLink>
        );
    };
    const DateBody = (data) => {
        return (
            <div>{formatedDate(data.employee_sale_date)}</div>
        );
    };

    const confirmDelete = (id, store_id) => {
        confirmDialog({
            message: 'Are you sure you want to delete this Sale?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => DeteteSaleProducts(id, store_id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Delete operation cancelled', life: 3000 });
            }
        });
    };

    const DeteteSaleProducts = async (id, store_id) => {
        try {
            const response = await axios.delete(`${apiUrl}/Management/DeleteEmployeeSale`, { params: { employee_sale_id: id, store_id }, headers });
            const { success, message } = response.data;
            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    return (
        <div className="container-fluid">
            <Toast ref={toast} />
            <div className="d-flex justify-content-between align-items-center mt-4">
                <div className="main-heading">
                    <h6>Employee Sale Report</h6>
                </div>
                <div className="main-heading-right">
                    <h6>Reports/Employee Sale Report</h6>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 mt-4">
                    <div className="card">
                        <div className="rounded-top px-3 py-2 bg-dark d-flex flex-wrap justify-content-between align-items-center">
                            <h4 className="text-white">Employee Sale Report</h4>
                        </div>
                        <div className='card-header'>
                            <div className="row">
                                <div className="col-md-3">
                                    <input
                                        type="date"
                                        className="form-control h-100"
                                        onChange={(e) => setStartDate(e.target.value)}
                                        value={startDate || ''}
                                        placeholder="Start date"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <input
                                        type="date"
                                        className="form-control h-100"
                                        onChange={(e) => setEndDate(e.target.value)}
                                        value={endDate || ''}
                                        placeholder="End date"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <select
                                        className="form-select h-100"
                                        value={Status || ""}
                                        onChange={(e) => setStatus(e.target.value)}>
                                        <option value="" disabled>Select Action Status</option>
                                        <option value={null}>All</option>
                                        <option value="0">Created</option>
                                        <option value="1">Edited</option>
                                        <option value="2">Deleted</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <div className="">
                                        <Button label="Filter"
                                            disabled={!keyword && !startDate && !endDate && !Status && !prStatus}
                                            icon="pi pi-filter" className="ms-3" onClick={applyFilters} />
                                        <Button
                                            disabled={!keyword && !startDate && !endDate && !Status && !prStatus}
                                            label="Clear" icon="pi pi-times" severity='secondary' className="ms-3" onClick={clearFilters} />
                                    </div>
                                </div>
                                <div className="mt-3 col-md-9"></div>
                                <div className="mt-3 col-md-3">
                                    <IconField iconPosition="left" className='w-100'>
                                        <InputIcon className="pi pi-search"> </InputIcon>
                                        <InputText
                                            onChange={(e) => setKeyword(e.target.value)}
                                            value={keyword}
                                            className='w-100'
                                            placeholder="Search..."
                                        />
                                    </IconField>
                                </div>
                            </div>
                        </div>
                        {dataTableLoading ? (
                            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => (
                                <Skeleton shape="rectangle" width="100%" height="40px" className="mb-1" />
                            ))
                        ) : (
                            <>
                                <div className="d-flex flex-wrap justify-content-between align-items-center">
                                    <div className="d-flex align-items-center p-3">
                                        <span className="me-2">Show:</span>
                                        <InputNumber
                                            value={rowsPerPage}
                                            onChange={(e) => setRowsPerPage(e.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    navigate(`/EmployeeSalesReport/${rowsPerPage}/${sortOrder}`)
                                                }
                                            }}
                                            mode="decimal"
                                            showButtons
                                            min={1}
                                            step={10}
                                            className="me-3"
                                        />
                                        <span className="me-2">entries</span>
                                    </div>
                                    <div className="d-flex align-items-center p-3">
                                        <span className="me-2">Sort Order:</span>
                                        <select
                                            className="form-select"
                                            value={sortOrder}
                                            onChange={(e) => { setSortOrder(e.target.value); navigate(`/EmployeeSalesReport/${rowsPerPage}/${e.target.value}`) }}
                                            style={{ width: '100px' }}
                                        >
                                            <option value="ASC">Ascending</option>
                                            <option value="DESC">Descending</option>
                                        </select>
                                    </div>
                                </div>
                                <DataTable
                                    value={rows}
                                    paginator
                                    rows={rowsPerPage}
                                    paginatorTemplate="CurrentPageReport PaginatorLeft"
                                    currentPageReportTemplate="Total Records: {totalRecords}"
                                    paginatorLeft={paginatorLeft}
                                    paginatorRight={<></>}
                                    sortOrder={sortOrder === 'ASC' ? 1 : -1}
                                >
                                    <Column field="employee_name" header="Employee" sortable />
                                    <Column field="store_name" header="Store" />
                                    <Column field={LinkBody} header="Invoice" />
                                    <Column field={DateBody} header="Date" />
                                    <Column field="user_name" header="By" />
                                    <Column header="Status" body={(data) => (
                                        data.employee_sale_status === 1 ?
                                            <Tag severity="warning" value={"Pending"} /> :
                                            <Tag severity="success" value={"Paid"} />
                                    )} />
                                    <Column field="grand_total_amount" header="Total" sortable />
                                    <Column body={ActionBody} header="Action" />
                                </DataTable>
                            </>

                        )}
                    </div>
                    <div className="mb-5"></div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeSalesReport;
